var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.582 12.811-1.256 1.568A13.246 13.246 0 0 1 7.62 9.674l1.569-1.255a1.066 1.066 0 0 0 .308-1.265l-1.43-3.22a1.066 1.066 0 0 0-1.243-.6L4.1 4.04a1.073 1.073 0 0 0-.79 1.184A15.819 15.819 0 0 0 16.774 18.69a1.073 1.073 0 0 0 1.185-.79l.706-2.723a1.067 1.067 0 0 0-.6-1.243l-3.22-1.43a1.065 1.065 0 0 0-1.264.308v0z",
    stroke: "#737680",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.51b49cdd4965e18fb759bacd74d28cc0.svg";
export { ForwardRef as ReactComponent };